<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Unidade</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="form-group col-md-1">
                      <label for="unidade_id">
                        <span class="required">*</span> Unidade ID Sigap:
                      </label>
                      <input autocomplete="new-password" type="text" id="unidade_id" class="form-control"
                        v-model="unidade.unidade_id" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="unidade_nome">
                        <span class="required"></span> Unidade Nome:
                      </label>
                      <input autocomplete="new-password" type="text" id="unidade_nome" class="form-control"
                        v-model="unidade.unidade_nome" placeholder="" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="tipo_unidade_id">
                        <span class="required">*</span> Tipo Unidade:
                      </label>
                      <v-select :options="tipo_unidades" :label="'nome'" :reduce="(tipo_unidades) => tipo_unidades.id"
                        v-model="unidade.tipo_unidade_id"></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="empresa_id">
                        <span class="required">*</span> Empresa:
                      </label>
                      <v-select :options="empresas" :label="'nome'" :reduce="(empresas) => empresas.id"
                        v-model="unidade.empresa_id"></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="url_img">
                        <span class="required"></span> URL Imagem:
                      </label>
                      <input autocomplete="new-password" type="file" id="url_img" class="form-control" placeholder="" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="url_site">
                        <span class="required"></span> URL Site:
                      </label>
                      <input autocomplete="new-password" type="text" id="url_site" class="form-control"
                        v-model="unidade.url_site" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="btn_background">
                        <span class="required"></span> Botão Background:
                      </label>
                      <input autocomplete="new-password" type="color" id="btn_background" class="form-control"
                        v-model="unidade.btn_background" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="btn_background_hover">
                        <span class="required"></span> Botão Background Hover:
                      </label>
                      <input autocomplete="new-password" type="color" id="btn_background_hover" class="form-control"
                        v-model="unidade.btn_background_hover" placeholder="" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="btn_background_error">
                        <span class="required"></span> Botão Background Error:
                      </label>
                      <input autocomplete="new-password" type="color" id="btn_background_error" class="form-control"
                        v-model="unidade.btn_background_error" placeholder="" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="btn_background_error_hover">
                        <span class="required"></span> Botão Background Error Hover:
                      </label>
                      <input autocomplete="new-password" type="color" id="btn_background_error_hover"
                        class="form-control" v-model="unidade.btn_background_error_hover" placeholder="" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="btn_color">
                        <span class="required"></span> Cor do Botão:
                      </label>
                      <input autocomplete="new-password" type="color" id="btn_color" class="form-control"
                        v-model="unidade.btn_color" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="numero_telefone_id">
                        <span class="required">*</span> Número Telefone ID:
                      </label>
                      <input autocomplete="new-password" type="text" id="numero_telefone_id" class="form-control"
                        v-model="unidade.numero_telefone_id" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="template">
                        <span class="required">*</span> Template:
                      </label>
                      <input autocomplete="new-password" type="text" id="template" class="form-control"
                        v-model="unidade.template" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="conta_whatsapp">
                        <span class="required">*</span> Conta WhatsApp:
                      </label>
                      <input autocomplete="new-password" type="text" id="conta_whatsapp" class="form-control"
                        v-model="unidade.conta_whatsapp" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="numero_telefone">
                        <span class="required">*</span> Número Telefone:
                      </label>
                      <input autocomplete="new-password" type="text" id="numero_telefone" class="form-control"
                        v-model="unidade.numero_telefone" placeholder="" />
                    </div>
                    <div class="form-group col-md-1">
                      <label for="mostrar_img">
                        <span class="required"></span> Mostrar Imagem:
                      </label>
                      <select v-model="unidade.mostrar_img" class="form-control">
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                      </select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="horas_para_envio">
                        <span class="required"></span> Horas para Envio:
                      </label>
                      <input autocomplete="new-password" type="text" id="horas_para_envio" class="form-control"
                        v-model="unidade.horas_para_envio" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="token">
                        <span class="required"></span> Token:
                      </label>
                      <input autocomplete="new-password" type="text" id="token" class="form-control"
                        v-model="unidade.token" placeholder="" />
                    </div>
                    <div class="form-group col-md-1">
                      <label for="status">
                        <span class="required">*</span> Status:
                      </label>
                      <select v-model="unidade.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                    <div class="form-group col-md-1">
                      <label for="telemedicina">
                        <span class="required"></span> Telemedicina:
                      </label>
                      <select v-model="unidade.telemedicina" class="form-control">
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                      </select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="redirect_id">
                        <span class="required"></span> Redirect ID:
                      </label>
                      <input autocomplete="new-password" type="text" id="redirect_id" class="form-control"
                        v-model="unidade.redirect_id" placeholder="" />
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group">
                    <div class="block text-right">
                      <router-link to="/unidades" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      departments: [],
      change_password: true,
      unidade: {
        status: '1',
      },
      empresas: [],
      tipo_unidades: [],
      errors: undefined,
      previewImage: null,
    };
  },
  methods: {

    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let imagem = document.getElementById("url_img");

      fd.append("unidade_id", self.unidade.unidade_id);
      fd.append("unidade_nome", self.unidade.unidade_nome);
      fd.append("tipo_unidade_id", self.unidade.tipo_unidade_id);
      fd.append("empresa_id", self.unidade.empresa_id);
      fd.append("url_site", self.unidade.url_site);
      fd.append("btn_background", self.unidade.btn_background);
      fd.append("btn_background_hover", self.unidade.btn_background_hover);
      fd.append("btn_background_error", self.unidade.btn_background_error);
      fd.append("btn_background_error_hover", self.unidade.btn_background_error_hover);
      fd.append("btn_color", self.unidade.btn_color);
      fd.append("numero_telefone_id", self.unidade.numero_telefone_id);
      fd.append("template", self.unidade.template);
      fd.append("conta_whatsapp", self.unidade.conta_whatsapp);
      fd.append("numero_telefone", self.unidade.numero_telefone);
      fd.append("mostrar_img", self.unidade.mostrar_img);
      fd.append("horas_para_envio", self.unidade.horas_para_envio);
      fd.append("token", self.unidade.token);
      fd.append("status", self.unidade.status);
      fd.append("telemedicina", self.unidade.telemedicina);
      fd.append("redirect_id", self.unidade.redirect_id);

      fd.append("_method", "POST");

      fd.append("url_img", imagem.files[0] ? imagem.files[0] : "");

      if (self.unidade.id) {
        fd.append("id", self.unidade.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "unidades";
      let fd = self.makeFormData();

      if (self.unidade.id) {
        self.unidade._method = "PUT";
        api += "/" + self.unidade.id;
      }

      axios
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Informações guardadas com sucesso`, "success");
          this.$router.push("/unidades");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getModeloPergunta: function (id) {
      const self = this;
      const api = self.$store.state.api + "unidades/" + id;

      axios
        .get(api)
        .then((response) => {
          self.unidade = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEmpresas: function () {
      const self = this;
      const api = self.$store.state.api + "empresas";

      axios
        .get(api)
        .then((response) => {
          self.empresas = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTipoUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_unidades";

      axios
        .get(api)
        .then((response) => {
          self.tipo_unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getEmpresas();
    self.getTipoUnidades();
    let id = self.$route.params.id;
    if (id) {
      self.getModeloPergunta(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
